<div class="block-wrapper d-unset">
  <div *transloco="let t; read: 'blocks.' + block.type" class="row no-gutters mx-n2 mb-0">
    <div [class]="block.settings.showBIC ? 'col-md-8' : 'col'" class="px-2 pb-3 pb-md-0">
      <div class="form-group">
        <label [for]="domId + slug">
          {{t('iban')}}
          <pl-required-indicator *ngIf="block.settings.required && blocksConfig.showRequiredIndicator && !ineligible" />
          <pl-readonly-indicator *ngIf="block.settings.readonly && blocksConfig.editable" />
        </label>

        <p class="sr-only" [id]="domId + slug + '-label'">
          {{block.localizedHelpText(currentContentLocale, originalContentLocale, true)}}
        </p>

        <input #input="ngModel"
               [(ngModel)]="data.iban"
               [class.is-invalid]="(!blocksConfig.editable || blocksConfig.preview) && formControl.touched && formControl.invalid"
               [class.is-valid]="(!blocksConfig.editable || blocksConfig.preview) && formControl.dirty && formControl.valid"
               [class.loading]="formControl.pending"
               [gizmoDestinationInput]="input.control"
               [gizmoDestination]="this"
               [id]="domId + slug"
               [ngModelOptions]="{standalone: true}"
               [placeholder]="!blocksConfig.printOptimized ? t('iban_placeholder') : ''"
               [disabled]="ineligible || (block.settings.readonly && blocksConfig.submittable && !blocksConfig.editable)"
               [readonly]="(block.settings.readonly && !blocksConfig.editable) || (!blocksConfig.editable && !blocksConfig.submittable)"
               [required]="block.settings.required"
               [attr.aria-describedby]="domId + slug + '-label'"
               (blur)="formControl.markAsTouched()"
               (ngModelChange)="onIbanChange($event)"
               class="form-control iban"
               ibanMask>
        <div *ngIf="formControl.invalid && formControl.touched" class="text-danger">
          <div *ngIf="(!blocksConfig.editable || blocksConfig.preview) && formControl.errors.required">
            {{t('errors.required')}}
          </div>
          <div *ngIf="formControl.errors.invalid">
            {{t('errors.invalid')}}
          </div>
        </div>
        <small *ngIf="block.localizedHelpText(currentContentLocale, originalContentLocale,true)"
               [class.text-danger]="blocksConfig.localizable && !block.localizedHelpText(currentContentLocale, originalContentLocale)"
               class="form-text text-muted"
               aria-hidden="true">
          {{block.localizedHelpText(currentContentLocale, originalContentLocale, true)}}
        </small>
      </div>
    </div>
    <div *ngIf="block.settings.showBIC" class="col-md-4 px-2">
      <div class="form-group">
        <label [for]="slug + '_bic'">{{'blocks.' + block.type + '.bic' | transloco}}</label>
        <input [id]="domId + slug + '_bic'"
               [ngModelOptions]="{standalone: true}"
               [ngModel]="data.bic"
               [placeholder]="!blocksConfig.printOptimized ? t('bic_placeholder') : ''"
               [attr.disabled]="!blocksConfig.printOptimized"
               class="form-control bic">
      </div>
    </div>
  </div>
</div>

<pl-ineligibility-overlay *ngIf="ineligible"></pl-ineligibility-overlay>
